import type { AuditConfigType, AuditEventFiltersType, AuditEventsResultType, AuditHealthType, AuditStatsType, SaveAuditConfigPayloadType } from '~/types/Audit'
import api from './api'

/** Parámetros de listado: los filtros más la paginación del servidor. */
export type AuditEventsParamsType = AuditEventFiltersType & { page?: number; limit?: number }

export const auditService = {
  async getConfig(scope?: 'system' | 'company', companyId?: string): Promise<AuditConfigType> {
    const params: Record<string, string> = {}
    if (scope) params.scope = scope
    if (companyId) params.companyId = companyId
    const { data } = await api.get('/audit/config', { params: Object.keys(params).length ? params : undefined })
    return data.data as AuditConfigType
  },

  async saveConfig(payload: SaveAuditConfigPayloadType & { companyId?: string }): Promise<AuditConfigType> {
    const { data } = await api.put('/audit/config', payload)
    return data.data as AuditConfigType
  },

  async getHealth(): Promise<AuditHealthType> {
    const { data } = await api.get('/audit/health')
    return data.data as AuditHealthType
  },

  async listEvents(params?: AuditEventsParamsType): Promise<AuditEventsResultType> {
    const { data } = await api.get('/audit/events', { params })
    return data.data as AuditEventsResultType
  },

  /**
   * Métricas del mismo conjunto que devuelve `listEvents`. Además de las
   * tarjetas, alimenta las listas de valores de los filtros: así sólo se
   * ofrecen recursos y acciones que existen de verdad.
   */
  async getStats(params?: AuditEventFiltersType): Promise<AuditStatsType> {
    const { data } = await api.get('/audit/stats', { params })
    return data.data as AuditStatsType
  }
}
